var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBListOrdered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-list-ordered",
    x: 0,
    y: 0,
    width: 24,
    height: 23.983,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.846,4.304c-0,0 1.479,-0.738 1.433,-0.716c0.134,-0.066 0.285,-0.103 0.445,-0.103c0.559,-0 1.012,0.453 1.012,1.012l0,4.989c0,0.559 -0.453,1.012 -1.012,1.012c-0.559,0 -1.013,-0.453 -1.013,-1.012l0,-3.351c-0.126,0.056 -0.266,0.088 -0.413,0.088c-0.559,0 -1.013,-0.453 -1.013,-1.013c0,-0.393 0.225,-0.735 0.559,-0.905l0.002,-0.001Zm-0.672,10.57l0.01,-0.024c0.347,-0.803 1.146,-1.365 2.076,-1.365c1.248,-0 2.26,1.012 2.26,2.26c-0,0.471 -0.145,0.909 -0.386,1.263l-0.002,0.002c-0.009,0.013 -0.018,0.026 -0.027,0.039l-1.068,1.424l0.47,0c0.559,0 1.013,0.454 1.013,1.013c-0,0.559 -0.454,1.013 -1.013,1.013l-2.494,-0c-0.559,-0 -1.013,-0.454 -1.013,-1.013c0,-0.229 0.077,-0.441 0.203,-0.607l2.262,-3.02c0.019,-0.033 0.03,-0.073 0.03,-0.114c-0,-0.13 -0.106,-0.235 -0.235,-0.235c-0.093,0 -0.174,0.055 -0.213,0.135c-0.001,0.003 -0.006,0.015 -0.006,0.015c-0.155,0.36 -0.513,0.612 -0.93,0.612c-0.559,-0 -1.013,-0.454 -1.013,-1.013c0,-0.139 0.029,-0.271 0.076,-0.385Zm18.826,-8.874c0.552,-0 1,0.448 1,1c-0,0.552 -0.448,1 -1,1l-12,-0c-0.552,-0 -1,-0.448 -1,-1c-0,-0.552 0.448,-1 1,-1l12,-0Zm-0,10c0.552,-0 1,0.448 1,1c-0,0.552 -0.448,1 -1,1l-12,-0c-0.552,-0 -1,-0.448 -1,-1c-0,-0.552 0.448,-1 1,-1l12,-0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBListOrdered);
export default __webpack_public_path__ + "static/media/iconB-list-ordered.b46f749f5c2f24e5b5eaad42d0bbbe56.svg";
export { ForwardRef as ReactComponent };